export const polePopupTemplate = () => {
  return {
    title: "Pole: {STRUCTURE_NAME}",
    actions: [
      {
        title: "Edit",
        id: "editPole",
        className: "esri-icon-edit",
      },
      {
        title: "View Photos",
        id: "viewPhotos",
        className: "esri-icon-media",
      },
    ],
    content: [
      {
        type: "fields",
        fieldInfos: [
          {
            fieldName: "STRUCTURE_NAME ",
            label: "Name",
          },
          {
            fieldName: "POLE_USE",
            label: "Type",
          },
          {
            fieldName: "ACCOUNTCODE",
            label: "Account Code",
          },
          {
            fieldName: "INVENTORY_STATUS_CODE",
            label: "Inventory Status Code",
          },
          {
            fieldName: "CREATIONUSER",
            label: "Created By",
          },
          {
            fieldName: "DATECREATED",
            label: "Date Created",
          },
          {
            fieldName: "LASTUSER",
            label: "Last Edited By",
          },
          {
            fieldName: "DATEMODIFIED",
            label: "Date Last Modified",
          },
          {
            fieldName: "THREEGISID",
            label: "THREEGISID",
          },
          {
            fieldName: "COMMENTS",
            label: "Comments",
          },
        ],
      },
    ],
  };
};

export const structurePopupTemplate = () => {
  return {
    title: "Structure: {STRUCTURE_NAME}",
    actions: [
      {
        title: "Edit",
        id: "editStructure",
        className: "esri-icon-edit",
      },
      {
        title: "View Photos",
        id: "viewPhotos",
        className: "esri-icon-media",
      },
    ],
    content: [
      {
        type: "fields",
        fieldInfos: [
          {
            fieldName: "STRUCTURE_NAME ",
            label: "Name",
          },
          {
            fieldName: "STRUCTURE_TYPE",
            label: "Type",
          },
          {
            fieldName: "INVENTORY_STATUS_CODE",
            label: "Inventory Status Code",
          },
          {
            fieldName: "ACCOUNTCODE",
            label: "Account Code",
          },
          {
            fieldName: "CREATIONUSER",
            label: "Created By",
          },
          {
            fieldName: "DATECREATED",
            label: "Date Created",
          },
          {
            fieldName: "LASTUSER",
            label: "Last Edited By",
          },
          {
            fieldName: "DATEMODIFIED",
            label: "Date Last Modified",
          },
          {
            fieldName: "THREEGISID",
            label: "THREEGISID",
          },
          {
            fieldName: "COMMENTS",
            label: "Comments",
          },
        ],
      },
    ],
  };
};

export const spliceClosurePopupTemplate = () => {
  return {
    title: "Splice Closure: {STRUCTURE_NAME}",
    actions: [
      {
        title: "Edit",
        id: "editSpliceClosure",
        className: "esri-icon-edit",
      },
      {
        title: "View Photos",
        id: "viewPhotos",
        className: "esri-icon-media",
      },
    ],
    content: [
      {
        type: "fields",
        fieldInfos: [
          {
            fieldName: "STRUCTURE_NAME ",
            label: "Name",
          },
          {
            fieldName: "SPLICECASETYPE",
            label: "Type",
          },
          {
            fieldName: "INVENTORY_STATUS_CODE",
            label: "Inventory Status Code",
          },
          {
            fieldName: "ACCOUNTCODE",
            label: "Account Code",
          },
          {
            fieldName: "CREATIONUSER",
            label: "Created By",
          },
          {
            fieldName: "DATECREATED",
            label: "Date Created",
          },
          {
            fieldName: "LASTUSER",
            label: "Last Edited By",
          },
          {
            fieldName: "DATEMODIFIED",
            label: "Date Last Modified",
          },
          {
            fieldName: "THREEGISID",
            label: "THREEGISID",
          },
          {
            fieldName: "COMMENTS",
            label: "Comments",
          },
        ],
      },
    ],
  };
};

export const greenfieldPopTemplate = () => {
  return {
    title: "Greenfield Photo Point",
    actions: [
      {
        title: "Edit",
        id: "editGreenfield",
        className: "esri-icon-edit",
      },
      {
        title: "View Photos",
        id: "viewPhotos",
        className: "esri-icon-media",
      },
    ],
  };
};

// export const photoPointPopupTemplate = () => {
//   return {
//     title: "Photo Point",
//     actions: [
//       {
//         title: "Edit photo point",
//         id: "editPhotoPoint",
//         className: "esri-icon-edit",
//       },
//     ],
//     content: [
//       {
//         type: "fields",
//         fieldInfos: [
//           {
//             fieldName: "STRUCTURE_NAME ",
//             label: "Name",
//           },
//           {
//             fieldName: "FEATURE",
//             label: "Type",
//           },
//           {
//             fieldName: "STATUS",
//             label: "Status",
//           },
//           {
//             fieldName: "CREATED_USER",
//             label: "Created By",
//           },
//           {
//             fieldName: "CREATED_DATE",
//             label: "Date Created",
//           },
//           {
//             fieldName: "LAST_EDITED_USER",
//             label: "Last Edited By",
//           },
//           {
//             fieldName: "LAST_EDITED_DATE",
//             label: "Date Last Modified",
//           },
//           {
//             fieldName: "THREEGISID",
//             label: "THREEGISID",
//           },
//           {
//             fieldName: "COMMENTS",
//             label: "Comments",
//           },
//         ],
//       },
//       { type: "attachments" },
//     ],
//   };
// };
